import { useIntl } from '@capsicum/common';
import { Button, Goat, Text, useRouter } from '@capsicum/common-web';
import styled from 'styled-components';

export const NoAssetsGoat = () => {
	const { $t } = useIntl();
	const { push } = useRouter();

	return (
		<Goat image="ankward" testID="sendAssets-noAssetsScreen-goat">
			<S.TextContainer>
				<Text variant="text1">{$t('ncWallet.send.assetSelector.noAssetGoat.title')}</Text>
				<Text variant="text5">{$t('ncWallet.send.assetSelector.noAssetGoat.body')}</Text>
			</S.TextContainer>
			<Button
				color="brand"
				testID="sendAssets-noAssetsScreen-backToWalletButton"
				text={$t('ncWallet.send.assetSelector.noAssetGoat.buttonText')}
				onClick={() => push('/nc-wallet')}
			/>
		</Goat>
	);
};

namespace S {
	export const TextContainer = styled.div`
		display: flex;
		flex-direction: column;
		text-align: center;
		gap: ${({ theme }) => theme.spacings.xxsmall};
	`;
}
